import React, { Component } from 'react';

export default class PortalCompanyPermission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companies: [],
            companyList: []
        }
    }

    componentDidMount() {
        this.getAllCompanies().then(result => {
            this.setState({
                companyList: result.map((item) => {
                    return {
                        'short_name': item.short_name,
                        'permission': 'access ' + item.short_name.toLowerCase(),
                        'isChecked': this.userHasCompanyPermission(item.short_name)
                    }
                })
            });
        });
    }

    userHasCompanyPermission(company_short_name) {
        if(!this.props.data.permissions){
            return false;
        }
        return (!(!this.props.data.permissions.find((permission) => {
            return permission.name.includes(company_short_name.toLowerCase())
        })));
    }

    changeCompanyPermission(i) {
        let companyList = this.state.companyList;
        companyList[i].isChecked = !companyList[i].isChecked;
        this.setState({
            companyList: companyList
        });
    }

    getAllCompanies() {
        return fetch('/api/v1/portal/companies/all', {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
            },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((companies) => {
                this.setState({
                    companies: companies
                })
            });
            return response;
        });
    }

    changeUserComapnyAccesibility() {
        $.ajax({
            url: "/api/v1/portal/portal-admin/change-user-account-company-access/" + this.props.data.id,
            data: JSON.stringify({ ...{'permissions': this.state.companyList}, api_token: window.api_token }),
            cache: false,
            method: 'post',
            contentType: "application/json",
            dataType: "json",
        })
        .done(function (data) {
            $('#infomodallabel').html('Success');
            $('#infomodal .modal-body').html(data);
            $('#infomodal').modal();
        })
        .catch(function (err) {
            let errors = err.responseText;
            errors = JSON.parse(errors);

            $('#infomodallabel').html('Error');
            $('#infomodal .modal-body').html('Sorry, ' + errors.error);
            $('#infomodal').modal();

        });
    }

    render() {

        const first_name = this.props.data.first_name;
        const permissions = this.props.data.permissions;
        return (
            <section>
                <div>
                    <h5>Company Permission</h5>
                </div>
                <div>
                    {this.state.companyList.length > 0 ?
                        this.state.companyList.map((item, i) => {
                            permissions
                            return <div className="checkbox" key={i}>
                                <label> Is {first_name} allowed to access {item.short_name} company?
                                    <input type="checkbox" name={"allowed_access_for_" + item.short_name}
                                        defaultValue="true"
                                        defaultChecked={item.isChecked}
                                        onChange={() => { this.changeCompanyPermission(i) }} />

                                    <span className="cr">
                                        <i className="cr-icon fa fa-check"></i>
                                    </span>
                                </label>
                            </div>
                        })
                        : null}

                    <p className="text-center">
                        <button className="btn btn-success" onClick={() => { this.changeUserComapnyAccesibility() }}>
                            <i className="fa fa-save"></i> Save Company Settings
                        </button>
                    </p>
                </div>
            </section>
        )
    }
}